import React from 'react';
import Image from 'next/image';

const ValuePropositionSection = () => {
  // Feature data for the product overview
  const features = [
    {
      title: "On-Demand Asset Generation",
      description: "Create personalized print and digital assets instantly — from one request to hundreds of thousands. We handle the infrastructure, you put the outputs to work.",
      icon: (
        <Image src="/images/icons/On Demand.png" alt="On-Demand Asset Generation Icon" width={55} height={55} />
      )
    },
    {
      title: "InDesign-to-Output Pipeline",
      description: "Design in Adobe InDesign, then let Personalia handle the production. No servers to manage, no software to install — just scalable output via API.",
      icon: (
        <Image src="/images/icons/InDesign.png" alt="InDesign-to-Output Pipeline Icon" width={55} height={55} />
      )
    },
    {
      title: "Connect to Any Stack",
      description: "Integrate with your tools and processes using our developer-friendly API or no-code options like Zapier.",
      icon: (
        <Image src="/images/icons/Developers.png" alt="Connect to Any Stack Icon" width={55} height={55} />
      )
    },
    {
      title: "Professional Design Quality",
      description: "Maintain brand consistency with professional layouts and creative control, designed in InDesign.",
      icon: (
        <Image src="/images/icons/High Design Quality.png" alt="Professional Design Quality Icon" width={55} height={55} />
      )
    },
    {
      title: "Lightning Fast",
      description: "Generate personalized assets in seconds with our high-performance cloud infrastructure. Scale from one to millions — we handle the heavy lifting.",
      icon: (
        <Image src="/images/icons/Lightning Fast.png" alt="Lightning Fast Icon" width={55} height={55} />
      )
    },
    {
      title: "Effortless Automation",
      description: "Set up workflows that run on autopilot — no manual steps, no bottlenecks. Just design and deploy.",
      icon: (
        <Image src="/images/icons/Easy Automation.png" alt="Effortless Automation Icon" width={55} height={55} />
      )
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Where Creativity Meets Automation</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Personalia connects your InDesign workflow to live data via our SaaS API. You focus on design — we handle the IT infrastructure, scalability, and production so you can generate assets on-demand, from one to hundreds of thousands.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-100 flex flex-row items-start">
              <div className="mr-6 flex-shrink-0">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
